import React from 'react';
import HeaderTwo from '../../../components/header/HeaderTwo';
import Footer from '../../../components/footer/Footer';
import Breadcrumb from './Breadcrumb';
import AboutInner from './AboutInner'
import VisionMission from './VisionMission'
import TeamMem from '../../team/TeamManagement'
import TeamArea from '../../team/TeamPlayer';

function AboutUs() {
  return (
	<>
	<HeaderTwo/>
	<main>
	<Breadcrumb/>
	<AboutInner/>
	
	<VisionMission/>
	<TeamMem/>
	<TeamArea/>
	</main>
	<Footer/>
	</>
  )
}

export default AboutUs
